import logo from './logo.svg';
import './App.css';
import Canvas from './components/Canvas';

function App() {
  return (
    <div className="App">
      <header className="App-header">
      <Canvas/>
      </header>
    </div>
  );
}

export default App;